import { CellProps } from "components/TreeState"
import { ChangedPlanRecord } from "../types"
import { Tooltip } from "@material-ui/core"
import WarningIcon from "@material-ui/icons/ErrorRounded"
import { css } from "@emotion/css"
import { useDefaultFieldIds } from "../useDefaultFieldIds"
import { useI18n } from "providers/I18n"
import { useParams } from "react-router-dom"
import { useSnapshot } from "valtio"
import { useTableSource } from "../TableStateProvider"

type InfoGetter = (
  t: (k: string) => string,
  resourceId: string,
  row: ChangedPlanRecord,
  defaultSemanticIds: Record<string, string>,
  primaryKey: string,
) => string | undefined

type InfoPerSemantic = Record<string, InfoGetter>

const infoPerSemantic: InfoPerSemantic = {}

export function Info(props: CellProps) {
  const { rowId: id, semantic, primaryKey } = props
  const { t } = useI18n()
  const { id: resourceId } = useParams<{ id: string }>()
  const tableSource = useTableSource()
  const readFrom = useSnapshot(tableSource.state)
  const defaultFieldIds = useDefaultFieldIds(id)
  const getInfo = semantic ? infoPerSemantic[semantic] : undefined

  if (!getInfo || !defaultFieldIds) return null
  const row = readFrom[id] as ChangedPlanRecord
  const info = getInfo(t, resourceId, row, defaultFieldIds, primaryKey)

  if (!info) return null

  return (
    <div className={styles.wrapper}>
      <Tooltip
        classes={{
          tooltip: styles.tooltip,
        }}
        placement="bottom"
        title={<span className="BodyBody-sWhiteRegular">{info}</span>}
        interactive={true}
      >
        <div className={styles.infoCn}>
          <WarningIcon color="inherit" />
        </div>
      </Tooltip>
    </div>
  )
}

const styles = {
  wrapper: css`
    position: absolute;
    top: 8px;
    left: 2px;
    width: min-content;
  `,
  tooltip: css`
    color: var(--white);
    background-color: var(--tertiary-light-yellow);
    margin: 0;
  `,
  infoCn: css`
    color: var(--tertiary-light-yellow);
  `,
}
